import React, { useEffect, useRef } from 'react';
import { Container, Text } from '@pixi/react';
import * as PIXI from 'pixi.js';
import { BoostedJackpotInfoPopupRulesKeys } from '../../../../../core/constants/gameRules';
import { applicationStore } from '../../../../../store/applicationStore';
import { setTranslationValues } from '../../../../../core/helpers/setTranslationValues';
import { isoStandard } from '../../../../../core/helpers/isoStandard';
import { canvasTranslationKeys } from '../../../../../core/constants/canvasTranslationKeys';
import { userInfoStore } from '../../../../../store/userInfoStore';

function BoostedJackpotInfoPopupRules({ rulesIcons }) {
  const refContainerText = useRef(null);

  useEffect(() => {
    let start = 0;
    BoostedJackpotInfoPopupRulesKeys.forEach(({ key, type, isSprite }) => {
      const textElementContainer = new PIXI.Container('TextElementContainer');
      const textElement = new PIXI.Text(
        key === canvasTranslationKeys.RULES_DESCRIPTION_2
          ? setTranslationValues(
              `${applicationStore.canvasTranslationKeys.RULES_DESCRIPTION_2} ${userInfoStore.currencySymbol}`,
              {
                VALUE: isoStandard(userInfoStore.limits.boostedJackpotBetAmount),
              }
            )
          : applicationStore.canvasTranslationKeys[key],
        {
          fontSize: type === 'title' ? 15 : 13,
          wordWrap: true,
          fontFamily: 'poppinsMedium',
          wordWrapWidth: 450,
          fontWeight: type === 'title' ? 700 : 400,
          fill: type === 'title' ? '#FFC33E' : '#FFFFFFE5',
        }
      );

      if (isSprite) {
        const icons = PIXI.Sprite.from(rulesIcons);
        icons.x = 105;
        icons.y = Math.ceil(start - 20);
        textElementContainer.addChild(icons);
        start += 30
      }
      textElement.y = Math.ceil(start);
      textElementContainer.addChild(textElement);

      start = textElement.y + textElement.height + (type === 'title' ? 15 : 10);
      refContainerText.current.addChild(textElementContainer);
    });
  }, [rulesIcons]);

  useEffect(() => {}, []);
  return (
    <Container name='BoostedJackpotInfoPopupRules' y={500}>
      <Text
        y={-10}
        x={220}
        anchor={0.5}
        text={applicationStore.canvasTranslationKeys.RULES}
        style={{
          fontSize: 18,
          fontWeight: 600,
          fontFamily: 'poppinsMedium',
          fill: '#F5F7FC',
          align: 'center',
          wordWrap: true,
          wordWrapWidth: 206,
        }}
        resolution={2}
      />
      <Container ref={refContainerText} y={50} />
    </Container>
  );
}

export default BoostedJackpotInfoPopupRules;
